module.exports = __webpack_public_path__ + "static/media/craps-calc-main.1a399640.png";